//
// products.js
//
// Copyright (c) 2015 by Curalate, Inc.
//
/* global angular:false */

((() => {
    const curalate = angular.module('curalate');

    curalate.controller('ProductsController', ['$scope',
        $scope => {
            $scope.$on('products:set-mode', ($event, args) => {
                $scope.mode = args.mode;
            });
        },
    ]);
}))();
